module.exports = __webpack_public_path__ + "img/f6-5.a3c05730.png";